export default "__VITE_ASSET__552a360b__"